<p-confirmDialog rejectButtonStyleClass="p-button-outlined"></p-confirmDialog>
<p-toast></p-toast>
<app-top-bar [topBarTitle]="topBarTitle"></app-top-bar>
<div class="bpt-main-content-container" style="overflow: auto" *ngIf="accessToTrainingItemGroup; else TrainingItemGroupNotAvailable">
  <div class="grid">
    <div class="col-4 eQMSScopeConfigurationTree">
      <p-treeSelect selectionMode="single" [filter]="true" [(ngModel)]="selectedNode" [options]="treeData"
        (onNodeSelect)="nodeSelect($event)" [placeholder]="treeSelectPlaceHolderText"></p-treeSelect>
    </div>
    <div class="col-4">
      <bpt-dropdown label="Training Item Group" [options]="trainingItemGroupList" [editable]="false"
        [(ngModel)]="selectedTrainingItemGroupNumber" id="courseScope" [showClear]="true" [showFilter]="true"
        [valueField]="valueField" [labelField]="labelField" (ngModelChange)="onTrainingItemGroupChange()">
      </bpt-dropdown>
    </div>
    <div class="col-4">
      <p-button appPreventDoubleClick styleClass="p-button-outlined" id="addTrainingItemButton" class="add-trainingItem-button  ml-2"
        icon="fa fa-plus" iconPos="left" pTooltip="Add Training Item Group" tooltipPosition="left"
        (debounceClick)="addTrainingItemGroup()"></p-button>
      <p-button appPreventDoubleClick icon="fa fa-pen" id="editTrainingItemButton"
        [disabled]="!enableEditTrainingItemGroupBtn" class="edit-trainingItem-button"
        pTooltip="Edit Training Item Group" tooltipPosition="left" iconPos="left"
        (debounceClick)="editTrainingItemGroup()"></p-button>
    </div>
  </div>
  <app-training-item-group-details *ngIf="loadTrainingItemGroupDetails && !isTrainingItemGroupDetailsLoading"></app-training-item-group-details>
  <app-training-item-group-slider *ngIf="isTrainingItemSliderOpen" [isTrainingItemSliderOpen]="isTrainingItemSliderOpen"
    (isTrainingItemSliderActive)="closeTrainingItemSlider($event)"></app-training-item-group-slider>
</div>

<ng-template #TrainingItemGroupNotAvailable>
  <app-error [errorMessage]="trainingItemGroupAccessErrorMessage()"></app-error>
</ng-template>